/** @jsxImportSource @emotion/react */
import {
  EuiPanel,
  EuiTitle,
  EuiSpacer,
  EuiText,
  EuiFlexGroup,
  EuiFlexItem,
} from "@inscopix/ideas-eui";
import { ButtonIconPermissioned } from "components/ButtonIconPermissioned/ButtonIconPermissioned";
import { ToolInfoBody } from "components/ToolProjectTabs/panels/ToolInfoBody";
import { useToolDataContext } from "pages/tool/ToolDataProvider";
import { isDefined } from "utils/isDefined";

interface ToolPanelAboutProps {
  goToSettingsTab?: () => void;
}

/*
 * Tool page sidebar panel with tool information
 * Edit action links to settings tab if goToSettingsTab is provided
 */
export const ToolPanelAbout = ({ goToSettingsTab }: ToolPanelAboutProps) => {
  const { tool } = useToolDataContext();

  return (
    <EuiPanel
      hasBorder={false}
      hasShadow={false}
      paddingSize="s"
      style={{ flexGrow: "0" }}
    >
      <EuiFlexGroup responsive={false}>
        <EuiFlexItem>
          <EuiTitle size="s">
            <span>About</span>
          </EuiTitle>
        </EuiFlexItem>
        {isDefined(goToSettingsTab) && (
          <EuiFlexItem grow={false}>
            <ButtonIconPermissioned
              aria-label="Edit tool details"
              requiredPermission="edit"
              iconType="pencil"
              onClick={goToSettingsTab}
            />
          </EuiFlexItem>
        )}
      </EuiFlexGroup>
      <EuiSpacer size="s" />
      <EuiText size="s">
        <p>{tool.help_text}</p>
      </EuiText>
      <EuiSpacer size="s" />
      <ToolInfoBody />
    </EuiPanel>
  );
};
